import { ORDER_COMPLETE_SERVICE_NAME } from "../../../../../../services/order"

import { OrderValidationController } from "./order-validation.contoller"

//#region Asset Imports

import * as TEMPLATE from './order-validation.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'ordersCompleteOrderValidation'

export class OrderValidationComponent {

    controller = [ORDER_COMPLETE_SERVICE_NAME, OrderValidationController]

    bindings = {
        options: '<',
    } as { [index: string]: string }

    template = TEMPLATE

}